// Eagerly resolves all flag SVGs to URLs at build time (replaces a dynamic require() webpack-ism that doesn't run under Vite).
// Kept as .js so import.meta.glob stays out of tsc.
const flags = import.meta.glob('../../static/flags/*.svg', {
  query: '?url',
  import: 'default',
  eager: true,
})

export default code => flags[`../../static/flags/${code}.svg`]
